module.exports = __webpack_public_path__ + "img/fk.f0dd71f4.svg";